import { hasCampaignsPlanAccess, shouldShowCampaignsNavItem } from './campaignsNavAccess'
import { isProPayingUser } from './campaignsNavAnnouncement'

const STORAGE_KEY_PREFIX = 'campaigns_bulk_action_announcement_dismissed'

export type CampaignsBulkAnnouncementAction = 'bulkDisconnect' | 'bulkMessage'

type CampaignsBulkAnnouncementWorkspace = Parameters<typeof isProPayingUser>[3]
type CampaignsBulkAnnouncementSubscription = Parameters<typeof isProPayingUser>[2]

export function getCampaignsBulkActionAnnouncementStorageKey(userId: string) {
    return `${STORAGE_KEY_PREFIX}_${userId}`
}

export function isCampaignsBulkActionAnnouncementDismissed(userId: string | undefined): boolean {
    if (!userId) return true
    return localStorage.getItem(getCampaignsBulkActionAnnouncementStorageKey(userId)) === 'true'
}

export function dismissCampaignsBulkActionAnnouncement(userId: string) {
    localStorage.setItem(getCampaignsBulkActionAnnouncementStorageKey(userId), 'true')
}

/**
 * Starter users see the announcement on the bulk disconnect (Remove) action,
 * paying Pro users on the bulk Message action. Users who already have campaigns
 * access (trial, Business, admin flag) never see it.
 */
export function shouldShowCampaignsBulkActionAnnouncement(
    action: CampaignsBulkAnnouncementAction,
    params: {
        userId: string | undefined
        trial: boolean
        lifetime: boolean
        subscription: CampaignsBulkAnnouncementSubscription
        workspace: CampaignsBulkAnnouncementWorkspace
    }
): boolean {
    const { userId, trial, lifetime, subscription, workspace } = params
    if (!userId) return false
    if (!shouldShowCampaignsNavItem(workspace)) return false
    if (hasCampaignsPlanAccess(workspace, trial)) return false
    if (isCampaignsBulkActionAnnouncementDismissed(userId)) return false
    if (action === 'bulkDisconnect') return !!workspace?.isStarter
    return isProPayingUser(trial, lifetime, subscription, workspace)
}
